import React, { FC, useRef, useState } from 'react';
import IconButton from 'src/components/atoms/buttons/IconButton';
import { addComma } from 'src/utils/common';
import NoResult from 'src/components/molecules/table/NoResult';

interface Props {
  data: any;
  viewType?: string;
  modifyItemEvt: (item: any) => void;
  deleteItemEvt: (item: any) => void;
}
const GridList: FC<Props> = ({ data, viewType, modifyItemEvt, deleteItemEvt }) => {
  const viewData: any = [];
  data.forEach((item: any, idx: number) => {
    const infoData = item.infoData || [];
    infoData.forEach((info: any, i: number) => {
      const setItem = {
        ...item,
        infoData: info,
      };
      viewData.push(setItem);
    });
  });

  const setData = [];
  const deleteEvt = (item: any) => {
    deleteItemEvt(item);
  };
  const modifyEvt = (item: any) => {
    modifyItemEvt(item);
  };

  const insurTypeView = (insurType: string) => {
    let typeView = '';
    switch (insurType) {
      case 'G0001':
        typeView = '일반 보장성보험';
        break;
      case 'G0002':
        typeView = '장애인 보장성보험';
        break;
      default:
        typeView = '일반 보장성보험';
        break;
    }
    return typeView;
  };
  return (
    <div className="_table_grid_layout _insurfree_grid">
      <div className="_grid">
        <div className="_label">
          <div className="_row _i_h3">
            {viewType === 'modify' ? (
              <>
                <div className="_col _wd_n01">
                  <div className="_tit"></div>
                </div>
              </>
            ) : (
              ''
            )}
            <div className="_col _wd_n0">
              <div className="_cont">
                계약자-피보험자
                <br />
                (종피보험자)
              </div>
            </div>
            <div className="_col _wd_n1">
              <div className="_cont">보험종류</div>
            </div>
            <div className="_col _wd_n2">
              <div className="_cont">
                <div className="_i_row _i_h0">
                  <div className="_i_col _right_np">보험납부내역</div>
                </div>
                <div className="_i_row _i_h0">
                  <div className="_i_col _w_p_50 _bor_r _right">국세청</div>
                  <div className="_i_col _w_p_50 _right">기타</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}

        <div className="_content">
          {viewData.map((item: any, idx: number) => {
            const infoData = item.infoData || {};

            return (
              <div className="_row _i_h2" key={idx}>
                {viewType === 'modify' ? (
                  <>
                    <div className="_col _wd_n01">
                      <div className="_cont">
                        <div className="_i_row ">
                          <div className="_i_col _w_p_50  _bor_r">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => modifyEvt(item)}
                                icon="ri-edit-box-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                          <div className="_i_col _w_p_50">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => deleteEvt(item)}
                                icon="ri-delete-bin-2-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ''
                )}
                <div className="_col _wd_n0">
                  <div className="_cont">{item.name}</div>
                </div>
                <div className="_col _wd_n1">
                  <div className="_cont">{insurTypeView(infoData.data_type)}</div>
                </div>
                <div className="_col _wd_n2_h">
                  <div className="_cont _right">{addComma(infoData.htx_amt)}</div>
                </div>
                <div className="_col _wd_n2_h">
                  <div className="_cont _right">{addComma(infoData.amt)}</div>
                </div>
              </div>
            );
          })}
          {viewData.length === 0 ? <NoResult /> : ''}
        </div>
      </div>
    </div>
  );
};

export default GridList;
